import React, { useState, useEffect } from "react";
import FooterNew from "../components/Footer-New.js";
import NavbarInner from "../components/Navbar-Inner";
import NavbarInnerSide from "../components/NavbarInnerSide.js";
import Sidebar from "../components/Sidebar.js";
import StakingList from "../components/Staking/Staking.js";


export default function Staking() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div>

      {/* <NavbarInner /> */}
      <NavbarInnerSide toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />

      <div className="flex w-full relative">
        <Sidebar isOpen={isSidebarOpen} closeSidebar={() => setIsSidebarOpen(false)} />
        <div className="flex-1 w-full overflow-hidden p-4">
          <StakingList />
        </div>
      </div>
      {/* <FooterNew/> */}
    </div>
  );
}
